import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <UpdatesSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <FaqSection />
        <AppSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <MediaSection />
        <IndexSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}